module.exports = __webpack_public_path__ + "static/media/hdExcavator.cecaa584.jpg";